import styled from "styled-components";

const Wrapper = styled.div<{
  width?: string;
  height?: string;
  display?: string;
  $justifyContent?: string;
  $alignItems?: string;
  $paddingLeft?: string;
}>`
  width: ${(props) => (props.width ? props.width : "10vw")};
  height: ${(props) => (props.height ? props.height : "4vw")};
  display: ${(props) => (props.display ? props.display : "flex")};
  justify-content: ${(props) =>
    props.$justifyContent ? props.$justifyContent : "center"};
  align-items: ${(props) => (props.$alignItems ? props.$alignItems : "center")};
  padding-left: ${(props) => (props.$paddingLeft ? props.$paddingLeft : "0")};
  /* border: 1px solid black; */
  font-size: 1.8vw;
`;

export default function SpaceBox(props: any) {
  const {
    width,
    height,
    display,
    justifyContent,
    alignItems,
    text,
    paddingLeft,
  } = props;

  return (
    <Wrapper
      width={width}
      height={height}
      display={display}
      $justifyContent={justifyContent}
      $alignItems={alignItems}
      $paddingLeft={paddingLeft}
    >
      {text}
    </Wrapper>
  );
}
